import { render, staticRenderFns } from "./StrategyCard.vue?vue&type=template&id=49f79e1c&"
import script from "./StrategyCard.vue?vue&type=script&lang=js&"
export * from "./StrategyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports